import { render, staticRenderFns } from "./WsExamsForm.vue?vue&type=template&id=5e722692"
import script from "./WsExamsForm.vue?vue&type=script&lang=js"
export * from "./WsExamsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports